import React, { useState } from "react";
import { formatDateWithoutHour } from "../utils/date";
import { formatCurrencyFromDb } from "../utils/masks";

const opcoesFormaPagamento = [
    { label: "DINHEIRO", value: "DINHEIRO" },
    { label: "PIX", value: "PIX" },
    { label: "BOLETO", value: "BOLETO" },
    { label: "CARTÃO DE CRÉDITO", value: "CARTÃO DE CRÉDITO" },
    { label: "CARTÃO DE DÉBITO", value: "CARTÃO DE DÉBITO" },
    { label: "TRANSFERÊNCIA BANCÁRIA", value: "TRANSFERÊNCIA BANCÁRIA" },
    { label: "CHEQUE", value: "CHEQUE" },
];

const tiposParcelamento = [
    { label: "Semanal", value: "semanal" },
    { label: "Quinzenal", value: "quinzenal" },
    { label: "Mensal", value: "mensal" },
];

function calcularProximasDatas(inicio, qtd, tipo) {
    const datas = [];
    let atual = new Date(inicio);
    for (let i = 0; i < qtd; i++) {
        datas.push(new Date(atual));
        if (tipo === "semanal") atual.setDate(atual.getDate() + 7);
        if (tipo === "quinzenal") atual.setDate(atual.getDate() + 15);
        if (tipo === "mensal") atual.setMonth(atual.getMonth() + 1);
    }
    return datas;
}

const PrevisaoPagamentos = ({
    valorTotal, // valor do orçamento, obrigatório, string ou number
    pagamentos,
    setPagamentos,
    valorDefaultDataInicial // se quiser sugerir data inicial do orçamento, senão pode remover
}) => {
    const [aberto, setAberto] = useState(false);
    const [tipo, setTipo] = useState("mensal");
    const [qtdParcelas, setQtdParcelas] = useState(1);
    const [dataInicial, setDataInicial] = useState(valorDefaultDataInicial || "");
    const [formaPagamento, setFormaPagamento] = useState(opcoesFormaPagamento[0].value);
    const [idxBaixa, setIdxBaixa] = useState(null);
    const [dataBaixa, setDataBaixa] = useState("");

    console.log('Pagamentos', pagamentos);


    // Gera previsões de pagamentos
    const handleGerar = () => {
        // Sempre lê do valorTotal recebido da prop
        let valorTotalFloat = valorTotal;
        if (typeof valorTotalFloat === "string") {
            valorTotalFloat = valorTotalFloat.replace("R$", "").replace(/\./g, "").replace(",", ".").trim();
            valorTotalFloat = parseFloat(valorTotalFloat);
        }
        if (isNaN(valorTotalFloat) || !dataInicial || qtdParcelas < 1) return;

        const datas = calcularProximasDatas(dataInicial, qtdParcelas, tipo);
        const valorParcela = (valorTotalFloat / qtdParcelas).toFixed(2);

        const novasPrevisoes = datas.map((data, idx) => ({
            ordem: idx + 1,
            valor: valorParcela,
            dataVencimento: data.toISOString().split("T")[0],
            formaPagamento: opcoesFormaPagamento.find(f => f.value === formaPagamento)?.label || "",
            status: "Pendente",
            dataPagamento: "",
        }));

        setPagamentos(novasPrevisoes);
    };

    // Para simular "baixa"
    const handleDarBaixa = (idx) => {
        setPagamentos((prev) =>
            prev.map((p, i) =>
                i === idx
                    ? { ...p, status: "Pago", dataPagamento: new Date().toISOString().split("T")[0] }
                    : p
            )
        );
    };

    const handleFormaPagamentoParcela = (idx, value) => {
        setPagamentos(prev =>
            prev.map((item, i) =>
                i === idx ? { ...item, formaPagamento: value } : item
            )
        );
    };

    const abrirModalBaixa = (idx) => {
        setIdxBaixa(idx);
        setDataBaixa(new Date().toISOString().slice(0, 10));
    };

    const confirmarBaixa = () => {
        setPagamentos(prev => prev.map((item, idx) =>
            idx === idxBaixa
                ? { ...item, status: "Pago", dataPagamento: dataBaixa }
                : item
        ));
        setIdxBaixa(null);
    };

    return (
        <div className="w-full">
            <button
                type="button"
                onClick={() => setAberto((v) => !v)}
                className="w-full flex justify-between items-center px-4 py-2 rounded-md border border-stone-400 bg-stone-100 mb-2"
            >
                <span className="font-medium text-base text-stone-700">
                    Previsão de Pagamentos
                </span>
                <span className="text-sm text-stone-400">{aberto ? "▲" : "▼"}</span>
            </button>
            {aberto && (
                <div className="p-4 border rounded-lg bg-white space-y-4">
                    <div className="grid grid-cols-1 sm:grid-cols-5 gap-4">
                        <div>
                            <label className="block text-sm font-medium text-stone-700">Tipo de Pagamento</label>
                            <select
                                className="w-full border rounded-md px-3 py-2 mt-1"
                                value={tipo}
                                onChange={(e) => {
                                    setTipo(e.target.value);
                                }}
                            >
                                {tiposParcelamento.map((t) => (
                                    <option key={t.value} value={t.value}>{t.label}</option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-stone-700">Quantidade de Parcelas</label>
                            <input
                                type="number"
                                min="1"
                                className="w-full border rounded-md px-3 py-2 mt-1"
                                value={qtdParcelas}
                                onChange={(e) => setQtdParcelas(Number(e.target.value))}
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-stone-700">Data Inicial</label>
                            <input
                                type="date"
                                className="w-full border rounded-md px-3 py-2 mt-1"
                                value={dataInicial}
                                onChange={(e) => setDataInicial(e.target.value)}
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-stone-700">Valor Total</label>
                            <input
                                type="text"
                                className="w-full border rounded-md px-3 py-2 mt-1 bg-gray-100"
                                value={
                                    typeof valorTotal === "number"
                                        ? valorTotal.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
                                        : valorTotal
                                }
                                readOnly
                                tabIndex={-1}
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-stone-700">Forma de Pagamento</label>
                            <select
                                className="w-full border rounded-md px-3 py-2 mt-1"
                                value={formaPagamento}
                                onChange={(e) => setFormaPagamento(e.target.value.toUpperCase())}
                            >
                                {opcoesFormaPagamento.map((f) => (
                                    <option key={f.value.toUpperCase()} value={f.value.toUpperCase()}>{f.label.toUpperCase()}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="flex items-center gap-4 mt-4">
                        <button
                            type="button"
                            className="bg-stone-700 text-white px-4 py-2 rounded-md font-medium shadow"
                            onClick={handleGerar}
                        >
                            Gerar Previsões
                        </button>
                        <span className="text-sm text-stone-500">
                            Valor Total: <b>{
                                typeof valorTotal === "number"
                                    ? valorTotal.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
                                    : valorTotal
                            }</b>
                        </span>
                    </div>
                    {/* Tabela das previsões */}
                    <div className="overflow-x-auto mt-4">
                        <table className="min-w-full bg-white border rounded-lg">
                            <thead>
                                <tr>
                                    <th className="px-4 py-2 border bg-stone-100">Parcela</th>
                                    <th className="px-4 py-2 border bg-stone-100">Vencimento</th>
                                    <th className="px-4 py-2 border bg-stone-100">Valor</th>
                                    <th className="px-4 py-2 border bg-stone-100">Forma</th>
                                    <th className="px-4 py-2 border bg-stone-100">Status</th>
                                    <th className="px-4 py-2 border bg-stone-100">Pagamento</th>
                                </tr>
                            </thead>
                            <tbody>
                                {pagamentos.map((item, idx) => (
                                    <tr key={idx}>
                                        <td className="border px-2 py-1 text-center">{item.ordem}</td>
                                        <td className="border px-2 py-1 text-center">{formatDateWithoutHour(item.dataVencimento)}</td>
                                        <td className="border px-2 py-1 text-center">
                                            {formatCurrencyFromDb(item.valor)}
                                        </td>
                                        <td className="border px-2 py-1 text-center">
                                            <select
                                                value={item.formaPagamento}
                                                className="border rounded px-2 py-1"
                                                onChange={e => handleFormaPagamentoParcela(idx, e.target.value)}
                                            >
                                                {opcoesFormaPagamento.map(f => (
                                                    <option key={f.value} value={f.value}>{f.label}</option>
                                                ))}
                                            </select>
                                        </td>
                                        <td className="border px-2 py-1 text-center">{item.status}</td>
                                        <td className="border px-2 py-1 text-center">
                                            {(item.status === "Pago" || item.status.id == 19) ? (
                                                formatDateWithoutHour(item.dataPagamento)
                                            ) : (
                                                <button
                                                    type="button"
                                                    className="bg-green-500 text-white px-2 py-1 rounded text-xs"
                                                    onClick={() => abrirModalBaixa(idx)}
                                                >
                                                    Dar Baixa
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
            {idxBaixa !== null && (
                <div className="fixed inset-0 bg-black/40 flex items-center justify-center">
                    <div className="bg-white p-6 rounded shadow-lg flex flex-col gap-4 min-w-[320px]">
                        <label className="font-medium">Data do Pagamento:</label>
                        <input
                            type="date"
                            value={dataBaixa}
                            onChange={e => setDataBaixa(e.target.value)}
                            className="border rounded px-2 py-1"
                        />
                        <div className="flex gap-3 justify-end mt-4">
                            <button
                                className="bg-gray-200 px-3 py-1 rounded"
                                onClick={() => setIdxBaixa(null)}
                            >
                                Cancelar
                            </button>
                            <button
                                className="bg-green-600 text-white px-3 py-1 rounded"
                                onClick={confirmarBaixa}
                            >
                                Confirmar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>


    );
};

export default PrevisaoPagamentos;
